import React from 'react'
import {validateEmail} from '@lib/helpers'

const Contact = ({children}) => {
  return (
    <section className='DemoDetail__contact' id='contact'>
      <div className='container'>
        {children}

        <p className='DemoDetail__contact__p'>
          ติดต่อเราวันนี้! ที่{' '}
          <a href='mailto:sales@datawow.io'>sales@datawow.io</a> หรือ โทร{' '}
          <a href='tel:020245560'>02-024-5560</a>
        </p>

        <form>
          <input type='text' name='name' placeholder='ชื่อของคุณ' required />
          <input
            type='email'
            name='email'
            placeholder='อีเมล์สำหรับการติดต่อกลับ'
            onBlur={validateEmail}
            required
          />
          <input
            type='tel'
            name='phone'
            placeholder='เบอร์โทรศัพท์'
            pattern='\d{10}'
            title='Please enter a 10-digit phone number'
            required
          />

          <button type='submit' className='DemoDetail__button'>
            ส่งข้อความ
          </button>
        </form>

        <div className='DemoDetail__contact__info'>
          <address>
            <strong>บริษัท เดต้า ว้าว จำกัด</strong>
            เลขที่ 1778 อาคารซัมเมอร์ฮับออฟฟิศ ชั้น 6 ถนนสุขุมวิท
            <br />
            แขวงพระโขนง เขตคลองเตย กรุงเทพมหานคร 10110 ประเทศไทย
          </address>

          <p>
            อีเมล์: <a href='mailto:sales@datawow.io'>sales@datawow.io</a>
            <br />
            โทร: <a href='tel:020245560'>02-024-5560</a>
          </p>
        </div>

        <nav className='DemoDetail__socials'>
          <a
            href='https://www.facebook.com/datawowai/'
            target='_blank'
            rel='nofollow noopener noreferrer'
            title='Facebook'
          >
            <img src='/images/demo/icon-facebook.svg' alt='Facebook' />
          </a>
          <a
            href='https://www.linkedin.com/company/datawowio/'
            target='_blank'
            rel='nofollow noopener noreferrer'
            title='Linkedin'
          >
            <img src='/images/demo/icon-linkedin.svg' alt='Linkedin' />
          </a>

          <a href='/blogs' title='DataWow Blog'>
            <img src='/images/demo/icon-blog.svg' alt='Blog' />
          </a>
        </nav>
      </div>
    </section>
  )
}

export default Contact
